/* unplugin-vue-components disabled */import script from "./SaveAttractInvestProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveAttractInvestProduct.vue?vue&type=script&setup=true&lang=js"

import "./SaveAttractInvestProduct.vue?vue&type=style&index=0&id=325e27c6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325e27c6"]])

export default __exports__